import styled from 'styled-components';

import { isMobileApp } from '../../../utils/getHost';

export const PageContent = styled.main`
    width: 100%;
    margin: 85px auto 25px; /* Allow for fixed navbar at top which has height of 60px */
    overflow: hidden;
    position: relative;
    flex-grow: 1;

    ${
        // No navbar on mobile app
        isMobileApp ? `
            margin: 0;
            padding: 20px;
        ` : ''
    }
`;

PageContent.displayName = 'PageContent';
